<template>
  <a
    class="sf-link"
    v-bind="$attrs"
    :class="{ 'sf-link--disabled': $attrs.disabled }"
  >
    <slot></slot>
  </a>
</template>
<script>
export default {
  name: 'SfLink',
  data() {
    return {}
  },
}
</script>
<style scoped lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.sf-link {
  font-family: $FAMILY-SANS-SERIF;
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column-gap: 4px;
}

.sf-link--disabled {
  pointer-events: none;
}
</style>
